module.exports = "/_next/static/images/404-Error@2x-72d1bd4ab85a746dea01c9e1682830ba.png";